export default "__VITE_ASSET__CtOkQt6b__"